import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemArName} from '../AMAR/FormChooseAmar.jsx'
import Model from './ModelArrd.mjs'

export const FormItemRdName = props => (
    <FormItemBizProp
        Model={Model}
        prop="rdName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemRdUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="rdUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseArrd(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemArName />
            <FormItemRdUserCode />
            <FormItemRdName />
        </FormChooseDesign>
    )
}
